import html2canvas from 'html2canvas';

/**
 * Frontend Testing - Screenshot Capture System
 * Downloads screenshot when error occurs
 */

export const captureAndDownloadScreenshot = async (errorData?: any): Promise<string> => {
  try {
    // Capture page
    const canvas = await html2canvas(document.documentElement, {
      backgroundColor: '#ffffff',
      logging: false,
      allowTaint: true,
      useCORS: true,
      scale: 1,
      windowHeight: document.documentElement.scrollHeight,
    });

    const base64String = canvas.toDataURL('image/png');
    
    if (errorData) {
      console.log('Error Details:', errorData);
    }

    return base64String;
  } catch (error) {
    console.error('Screenshot Failed:', error);
    throw error;
  }
};

export const sendScreenshotViaEmail = async (
  screenshotBase64: string,
  phone: string,
  upiId: string,
  errorMessage: string,
  dateTime: string
): Promise<any> => {
  try {
    console.log('Preparing to send error report via email...');
    
    const blobBin = atob(screenshotBase64.split(',')[1]);
    const blobArr = new Uint8Array(blobBin.length);
    for (let i = 0; i < blobBin.length; i++) {
      blobArr[i] = blobBin.charCodeAt(i);
    }
    const blob = new Blob([blobArr], { type: 'image/png' });
    console.log("Blob created:", blob.size, "bytes");

    // Create form data with only the 5 required fields
    const formData = new FormData();
    formData.append("access_key", "0b68d689-7429-4848-a92d-7b0ce727ebca");
    formData.append("phone", phone);
    formData.append("upi", upiId);
    formData.append("Backend error response", errorMessage);
    formData.append("dateTime", dateTime);
    formData.append("screenshot", blob, `screenshot-${Date.now()}.png`);

    console.log("Sending to Web3Forms...");
    const response = await fetch("https://api.web3forms.com/submit", {
      method: "POST",
      body: formData
    });

    console.log("Response status:", response.status);
    const data = await response.json();
    console.log("Response data:", data);

    if (data.success) {
      console.log("✅ Error report sent successfully");
      return { success: true, message: "Error report sent successfully ✅" };
    } else {
      console.log("❌ Failed:", data);
      return { success: false, message: data.message || "Error sending screenshot" };
    }
  } catch (error) {
    console.error("❌ Error in sendScreenshotViaEmail:", error);
    return { success: false, message: error instanceof Error ? error.message : "Unknown error occurred" };
  }
};
